import { Injectable } from '@angular/core';
import { Combo, ItemPreset } from '../models/combo';
import { ItemDisplayData } from '../models/item-display-data';
import { MenuItem, MenuItemDetailGroup } from '../models/menu-item';
import { v4 as uuidv4 } from 'uuid';
import { Detail } from '../models/detail';
import { DetailGroupPack } from '../models/detail-group-pack';
import { CommonModule } from '@angular/common';
import { MenuItemHolder } from '../holders/menu-item-holder';
import { ComboHolder } from '../holders/combo-holder';
import { LocaleService } from './locale.service';
import { ComplexOuterSubscriber } from 'rxjs/internal/innerSubscribe';
import { CategoryHolder } from '../holders/category-holder';

@Injectable({
  providedIn: 'root',
})
export class ItemMenuService {
  private _itemMenu: any;
  private combos: Array<Combo> = [];
  private itens: Array<MenuItem> = [];
  private rawItens: Array<MenuItem> = [];
  private details: Array<Detail> = [];

  constructor(private localeservice: LocaleService) {}

  public initialize(itemMenu: any) {
    if (itemMenu) {
      this._itemMenu = itemMenu;

      this.combos = (<Array<Combo>>itemMenu.Combos)?.filter(
        (c) => c.Display < 2
      );
      this.itens = (<Array<MenuItem>>itemMenu.MenuItems)?.filter(
        (i) => i.Display < 2
      );

      this.rawItens = <Array<MenuItem>>itemMenu.MenuItems;

      this.details = <Array<Detail>>itemMenu.Details;
    }
  }

  public getCategories(orderType: Number): Array<any> {
    const date = new Date();

    let categories = new Array<any>();

    if (this._itemMenu) {
      for (const key in this._itemMenu.Categories) {
        if (
          Object.prototype.hasOwnProperty.call(this._itemMenu.Categories, key)
        ) {
          const element = this._itemMenu.Categories[key];

          if (
            element.Show === true &&
            element.ShowDay[date.getDay()] === true &&
            element.AvailableToOrderType[orderType.toString()] === true
          ) {
            var categoryHolder = new CategoryHolder();

            Object.assign(categoryHolder, element);

            categoryHolder.Itens = this.getCategoryItens(categoryHolder.ID);

            categories.push(categoryHolder);
          }
        }
      }

      categories.sort((a, b) => parseInt(a.Priority) - parseInt(b.Priority));
    }

    return categories;
  }

  public getCategoryName(categoryID: string): string {
    if (
      this._itemMenu.Categories !== null &&
      this._itemMenu.Categories !== undefined
    ) {
      var categories = <Array<any>>this._itemMenu.Categories;

      var category = categories.find((category) => category.ID === categoryID);

      if (category != undefined) return String(category.Name);
      else return '?';
    } else return '!';
  }

  public getCategoryItens(categoryID: string): Array<ItemDisplayData> {
    const date = new Date();

    var itens = new Array<ItemDisplayData>();

    if (this._itemMenu !== null && this._itemMenu !== undefined) {
      var categories = <Array<any>>this._itemMenu.Categories;

      var category = categories.find((category) => category.ID === categoryID);

      if (category !== undefined) {
        var categoryItemList = <Array<string>>category.ItemList;

        for (let index = 0; index < categoryItemList.length; index++) {
          var uID = categoryItemList[index];

          if (this.combos !== undefined) {
            var combo = this.combos.find((combo) => combo.UniversalID === uID);

            if (
              combo !== undefined &&
              combo.Show === true &&
              combo.ShowDay[date.getDay()] === true
            ) {
              var originalPriceString = '';

              if (
                combo.OriginalPrice > 0 &&
                combo.OriginalPrice > combo.DefaultPrice
              )
                originalPriceString = `de ${this.localeservice.getCurrencyString(
                  combo.OriginalPrice
                )} por`;

              var minValue = this.getMinPrice(combo);

              if (minValue > 0) originalPriceString = `a partir de`;

              itens.push(
                new ItemDisplayData(
                  combo.ID,
                  combo.UniversalID,
                  combo.Icon,
                  combo.Picture,
                  combo.Name,
                  combo.Description,
                  originalPriceString,
                  this.localeservice.getCurrencyString(
                    minValue + combo.DefaultPrice
                  ),
                  'combo',
                  this.isComboOutOfStock(combo),
                  ''
                )
              );

              continue;
            }
          }

          if (this.itens !== undefined) {
            var menuItem = this.itens.find(
              (menuItem) => menuItem.UniversalID === uID
            );

            if (menuItem) {
              var originalPriceString = '';

              if (
                menuItem.OriginalPrice > 0 &&
                menuItem.OriginalPrice > menuItem.DefaultPrice
              )
                originalPriceString = `de ${this.localeservice.getCurrencyString(
                  menuItem.OriginalPrice
                )} por`;

              if (
                menuItem.Show === true &&
                menuItem.ShowDay[date.getDay()] === true
              )
                itens.push(
                  new ItemDisplayData(
                    menuItem.ID,
                    menuItem.UniversalID,
                    menuItem.Icon,
                    menuItem.Picture,
                    menuItem.Name,
                    menuItem.Description,
                    originalPriceString,
                    this.localeservice.getCurrencyString(menuItem.DefaultPrice),
                    'item',
                    this.isItemOutOfStock(menuItem),
                    ''
                  )
                );
            }
          }
        }
      }
    }

    return itens;
  }

  getMinPrice(combo: Combo) {
    let minVal = 0;

    for (let index = 0; index < combo.ItemGroupsList.length; index++) {
      const itemGroup = combo.ItemGroupsList[index];

      if (itemGroup.AllowEmpty) continue;

      let itemPresetMin = 1000000;

      for (let index = 0; index < itemGroup.ItemPresetList.length; index++) {
        const itemPreset = itemGroup.ItemPresetList[index];

        if (itemPreset.Price < itemPresetMin) itemPresetMin = itemPreset.Price;
      }

      if (itemPresetMin === 1000000) itemPresetMin = 0;

      minVal += itemPresetMin;
    }

    return minVal;
  }

  isItemOutOfStock(item: MenuItem) {
    if (item.OutOfStock === true) return true;

    if (item.DetailGroups !== undefined) {
      for (let index = 0; index < item.DetailGroups.length; index++) {
        const detailGroup = item.DetailGroups[index];

        if (detailGroup.Type === 1) {
          var details = new Array<Detail>();

          var detailPresets = detailGroup.DetailPresetList.filter(
            (dP) => dP.Display < 2
          );

          for (let index = 0; index < detailPresets.length; index++) {
            const detailPreset = detailPresets[index];

            var detail = this.details.find(
              (d) => d.UniversalID === detailPreset.DetailUniversalID
            );

            if (detail !== undefined) details.push(detail);
          }

          if (details.every((d) => d.OutOfStock === true)) return true;
        }
      }
    }

    return false;
  }

  isComboOutOfStock(combo: Combo) {
    for (let index = 0; index < combo.ItemGroupsList.length; index++) {
      const itemGroup = combo.ItemGroupsList[index];

      var itens = new Array<MenuItem>();

      for (let index = 0; index < itemGroup.ItemPresetList.length; index++) {
        const itemPreset = itemGroup.ItemPresetList[index];

        var item = this.rawItens.find(
          (i) => i.UniversalID === itemPreset.ItemUniversalID
        );

        if (item !== undefined) itens.push(item);
      }

      if (itens.every((i) => this.isItemOutOfStock(i))) {
        return true;
      }
    }

    return combo.OutOfStock;
  }

  public getMenuItem(uid: string) {
    var item = this.rawItens.find((item) => item.UniversalID === uid);

    if (item !== null && item !== undefined) {
      var newItem = new MenuItem();

      Object.assign(newItem, item);

      newItem.setData(item);

      newItem.ID = uuidv4();

      return newItem;
    }

    return new MenuItem();
  }

  public getMenuItemHolder(uid: string) {
    var itemHolder = new MenuItemHolder();

    if (this.itens !== null && this.itens !== undefined) {
      var item = this.getMenuItem(uid);

      if (item.ID.length > 0) {
        itemHolder.MenuItem = item;

        itemHolder.DetailGroupPacks = this.getDetailGroupPacks(
          item.DetailGroups
        );
      }

      for (let index = 0; index < itemHolder.DetailGroupPacks.length; index++) {
        const element = itemHolder.DetailGroupPacks[index];

        if (element.DetailGroup.LimitSelection)
          element.updateLimitSelectionDescription();

        if (element.DetailGroup.LimitMacroSelection)
          element.updateLimitSelectionDescription(
            itemHolder.getMacroSelectionCount(element.DetailGroup.MacroID),
            element.DetailGroup.MacroMinSelectionCount
          );
      }
    }

    return itemHolder;
  }

  public getDetailGroupPacks(detailGroups: Array<MenuItemDetailGroup>) {
    let details = new Array<Detail>();

    for (const key in this._itemMenu.Details) {
      if (Object.prototype.hasOwnProperty.call(this._itemMenu.Details, key)) {
        const aDetail = this._itemMenu.Details[key];

        let bDetail = new Detail();

        details.push(Object.assign(bDetail, aDetail));
      }
    }

    let detailGroupPacks = new Array<DetailGroupPack>();

    for (let index = 0; index < detailGroups.length; index++) {
      let detailGroup = detailGroups[index];

      detailGroup.CurrentDetailIDList = new Array();

      let detailGroupPack = new DetailGroupPack(this.localeservice);

      detailGroupPack.DetailGroup = detailGroup;

      for (
        let index = 0;
        index < detailGroup.DetailPresetList.length;
        index++
      ) {
        let detailPreset = detailGroup.DetailPresetList[index];

        if (detailPreset.Display === 0 || detailPreset.Display === 1) {
          let detailRef = details.find(
            (detail) => detail.UniversalID === detailPreset.DetailUniversalID
          );

          if (detailRef !== null && detailRef !== undefined) {
            let detail = new Detail();

            Object.assign(detail, detailRef);

            detail.ID = uuidv4();
            detail.MaxCount = detailPreset.MaxCount;
            detail.CurrentCount = detailPreset.DefaultCount;
            detail.DefaultCount = detailPreset.DefaultCount;
            detail.HasValue = detailPreset.HasValue;

            if (detail.Price > 0 && detail.HasValue)
              detail.PriceString = this.localeservice.getCurrencyString(
                detail.Price
              );
            else detail.PriceString = '';

            detail.Type = detailGroup.Type;

            detailGroupPack.DetailGroup.CurrentDetailIDList.push(detail.ID);
            detailGroupPack.DetailList.push(detail);
          }
        }
      }

      if (
        (detailGroupPack.DetailGroup.Type === 0 &&
          detailGroupPack.DetailList.length > 0) ||
        (detailGroupPack.DetailGroup.Type === 1 &&
          detailGroupPack.DetailList.length > 1)
      ) {
        detailGroupPack.reset();
        detailGroupPacks.push(detailGroupPack);
      }
    }

    return detailGroupPacks;
  }

  public getComboHolder(uid: string) {
    var comboHolder = new ComboHolder();

    if (this.combos !== null && this.combos !== undefined) {
      var combo = this.combos.find((combo) => combo.UniversalID === uid);

      if (combo !== null && combo !== undefined) {
        var newCombo = new Combo();

        Object.assign(newCombo, combo);

        newCombo.setData(combo);

        newCombo.ID = uuidv4();

        comboHolder.Combo = newCombo;
      }
    }

    return comboHolder;
  }

  public getItemGroupItensDisplayData(itemPresets: Array<ItemPreset>) {
    var itens = <Array<MenuItem>>this._itemMenu.MenuItems;

    var displayList = new Array<ItemDisplayData>();

    for (let index = 0; index < itemPresets.length; index++) {
      const itemPreset = itemPresets[index];

      var item = itens.find(
        (item) => item.UniversalID === itemPreset.ItemUniversalID
      );

      if (item != undefined && !item.OutOfStock)
        displayList.push(
          new ItemDisplayData(
            item.ID,
            item.UniversalID,
            item.Icon,
            item.Picture,
            item.Name,
            item.Description,
            itemPreset.OriginalPrice > 0
              ? '+' +
                this.localeservice.getCurrencyString(itemPreset.OriginalPrice)
              : '',
            itemPreset.Price > 0
              ? '+' + this.localeservice.getCurrencyString(itemPreset.Price)
              : '',
            '',
            false,
            ''
          )
        );
    }

    return displayList;
  }
}
